import { items } from "./items/index";
import { IData, IProperty, IPropertyConfig, PropertyEvents } from "./types";
import { create, el } from "@dhx/ts-common/dom";
import { EventSystem, IEventSystem } from "@dhx/ts-common/events";
import { View } from "@dhx/ts-common/view";
import { DataCollection, DataEvents, IDataCollection } from "@dhx/ts-data";

export class Property extends View implements IProperty {
	public events: IEventSystem<PropertyEvents>;
	public data: IDataCollection;
	private _data: IData;

	constructor(cont: string | HTMLElement, config?: IPropertyConfig) {
		super(cont, config);
		this.events = new EventSystem<PropertyEvents>();
		this.data = new DataCollection();
		const view = create(
			{
				render(_vm, obj: Property) {
					return obj._toVDOM();
				},
			},
			this
		);
		this.events.on(PropertyEvents.afterFileUpload, () => this.paint());
		this.data.events.on(DataEvents.load, () => {
			this._parseStruct();
		});
		this.mount(cont, view);
	}
	clear(): void {
		this.data.map(obj => obj.$item.clear());
	}
	getValues(): IData {
		const data = this.data.reduce((acc, obj) => {
			acc[obj.id] = obj.$item.getValue();
			return acc;
		}, {});
		return data;
	}
	setValues(data: IData): void {
		this._data = data;
		this.data.forEach(obj => {
			const itemValue = this._data[obj.id];
			if (itemValue) {
				obj.$item.clear();
				obj.$item.setValue(itemValue, true);
			} else if (typeof obj.$item.clear === "function") {
				obj.$item.clear();
			}
		});
	}
	isItemSelected(id: string): boolean {
		const obj = this.data.getItem(id);
		const uid = obj ? obj._uid : "";
		if (uid) {
			return this.getRootView().refs[uid].el === document.activeElement;
		}
		return false;
	}
	isItemsSelected(): boolean {
		const refs = this.getRootView().refs;
		let focused = false;
		for (const key in refs) {
			if (refs[key].el === document.activeElement) {
				focused = true;
			}
		}
		return focused;
	}
	selectItem(id: string): void {
		const obj = this.data.getItem(id);
		const uid = obj && obj.$item ? obj.$item._uid : "";
		const refs = this.getRootView().refs;
		if (uid && refs) {
			refs[uid].el.focus();
		}
	}
	private _parseStruct(): void {
		this.data.map(obj => {
			obj.$item = new items[obj.type](obj, this.events);
		});
		this.paint();
	}
	private _toVDOM() {
		const components = this.data.map(obj => obj.$item.toVDOM(this.getRootView()));
		return el(".dhx_property", [...components]);
	}
}
